import saMessages from '../locales/fa_IR.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'fa-IR',
};
export default saLang;
